/**
 * Checks if we have a `label` and `url` on an image
 */ function isValidImages(imagesArray) {
    return !!imagesArray && imagesArray.some((item)=>item.label && item.url
    );
}

export { isValidImages as default };
//# sourceMappingURL=is-valid-images.js.map
